import { Component, HostListener, OnDestroy, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import * as $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { NgxPermissionsService } from 'ngx-permissions';
import { userInfo } from 'os';
import { Subscription, firstValueFrom } from 'rxjs';
import { CommonServiceService } from 'src/app/Services/common-service.service';
import { onUserLogin, onUserLogout } from 'src/app/Services/datadog-session';
import { DatadogService } from 'src/app/Services/datadog.service';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { Apps, RootCompany } from 'src/app/enum/enum';
import { environment } from 'src/app/environments/environment';

import {
  Companieslist,
  Inventory,
  LoginModel,
  RumSettings,
  UserModel,
  UserPermissionsModel,
  usersDetails
} from '../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { AdminBreadcrumbsService } from '../admin-services/admin-breadcrumbs.service';
import { AnalyticsMenuItem, AnalyticsMenuService } from '../admin-services/analytics-menu.service';
import { LifecycleEnrollmentService } from '../admin-services/lifecycle-enrollment.service';
import { getReportRoute } from '../admin-services/report-routes.config';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnDestroy {
  private routerSub?: Subscription;
  isMenuOpen: boolean = false;
  userInfo: LoginModel = new LoginModel();
  isDropdownOpen: boolean = false;
  breadcrumbs: any[] = [];
  mainLinks: any[] = [];
  analyticsSubmenus: AnalyticsMenuItem[] = [];
  selectedcolor: string = 'ORANGE';
  productionScheduleType: string = '';
  companieslist: Array<Companieslist> = [];
  dataDagConfig: RumSettings = new RumSettings();
  isMenuItemActive: boolean[] = [true, false, false, false, false, false, false, false, false, false];
  toggleIndex: number = 0;
  IsMenuopen: boolean = false;
  showBotModalButton: boolean = false;
  listerUrl: string = environment.listerWebBaseUrl;
  posUrl: string = environment.posWebBaseUrl;
  companyUrl: string = environment.companyWebBaseUrl;
  inventoryUrl: string = environment.inventoryWebBaseUrl;
  user: any;
  contextMenuPosition = { x: '0px', y: '0px' };
  showContextMenu = false;
  selectedApp: any = null;
  currentUserRoles: any;
  userRoleDetails: any;
  showWeekColorsMenu: boolean = true;
  isV3ReportsEnrolled: boolean = false;
  allMenus = [
    {
      id: 1,
      menu: 'Reports',
      submenus: {
        submenuArray: [
          {
            id: 1,
            menu: 'Employee Report',
            permission: 'Report:ViewEmployee'
          },
          {
            id: 2,
            menu: 'Production Overview',
            permission: 'Report:ViewProductionOverview'
          },
          {
            id: 3,
            menu: 'Top Performer',
            permission: 'Report:ViewTopPerformer'
          },
          {
            id: 4,
            menu: 'Sell Through Report',
            permission: 'Report:ViewSellThrough'
          },
          {
            id: 5,
            menu: 'Sales Productivity Report'
          }
        ]
      }
    },
    {
      id: 2,
      menu: 'Company',
      submenus: {
        submenuArray: [
          {
            id: 5,
            menu: 'API Users',
            permission: 'APIUser:View'
          },
          {
            id: 6,
            menu: 'Goals',
            permission: 'Goal:View'
          },
          {
            id: 7,
            menu: 'Print Formats',
            permission: 'Label:View'
          },
          {
            id: 8,
            menu: 'Pricing',
            permission: 'Pricing:View'
          },
          {
            id: 9,
            menu: 'Quality',
            permission: 'Quality:View'
          },
          {
            id: 10,
            menu: 'Size',
            permission: 'Size:View'
          },
          {
            id: 11,
            menu: 'Week Colors',
            permission: 'WeekColor:View'
          }
        ]
      }
    },
    {
      id: 3,
      menu: 'Inventory',
      submenus: {
        submenuArray: [
          {
            id: 13,
            menu: 'Counting',
            permission: 'Item:UpdateCount'
          },
          {
            id: 14,
            menu: 'Item On Hand',
            permission: 'Item:ViewItemsOnHand'
          },
          {
            id: 15,
            menu: 'Movement',
            permission: 'Item:MoveToLocation'
          },
          {
            id: 16,
            menu: 'Transfer',
            permission: 'Item:MoveToStore'
          },
          {
            id: 17,
            menu: 'Containers',
            permission: 'Bin:View'
          }
        ]
      }
    }
  ];
  allMenusCopy = JSON.parse(JSON.stringify(this.allMenus));

  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private masterService: MasterDataSeriveService,
    private route: Router,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private router: Router,
    private cookie: CookieService,
    private commonService: CommonServiceService,
    private datadogService: DatadogService,
    private analyticsMenuService: AnalyticsMenuService,
    private lifecycleEnrollmentService: LifecycleEnrollmentService
  ) {
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setActiveMenu(event.urlAfterRedirects);
      }
    });
  }

  ngOnInit() {
    this.userInfo = this.masterService.getUserDetailsFromStorage();
    this.selectedcolor = this.userInfo.productionCycleColor;
    this.productionScheduleType = this.userInfo.productionScheduleType ?? '';
    this.showWeekColorsMenu = this.productionScheduleType.toString().trim().toLowerCase() !== 'datespecific';
    this.addDatadogRum();
    this.initializeData();
    this.getcompanieslist();
    this.getBreadcrums();
    this.getPermissionsByUserId();
    this.getUserDetails();
    this.analyticsMenuService.getMenuItems().subscribe(items => {
      this.analyticsSubmenus = items;
    });
    this.lifecycleEnrollmentService.isEnrolled$().subscribe(isEnrolled => {
      this.isV3ReportsEnrolled = isEnrolled;
    });
  }
  async addDatadogRum() {
    const config = await firstValueFrom(this.datadogService.getDatadogConfig(RootCompany.RootCompanyId));
    this.dataDagConfig = config;
    if (this.dataDagConfig.enableRumForTpmApp) {
      onUserLogin(this.userInfo);
    }
  }
  setActiveMenu(url: string) {
    this.isMenuItemActive.fill(false);

    if (url.includes('/admin/home/admin-home')) {
      this.isMenuItemActive[0] = true;
    } else if (
      url.includes('/admin/home/emp-report') ||
      url.includes('/admin/home/production-overview') ||
      url.includes('/admin/home/top-performer') ||
      url.includes('/admin/home/sell-through') ||
      url.includes('/admin/home/pending-override') ||
      url.includes('/admin/home/sale-per-producer-report') ||
      url.includes('/admin/home/v3/')
    ) {
      this.isMenuItemActive[1] = true;
    } else if (url.includes('/admin/home/stations')) {
      this.isMenuItemActive[2] = true;
    } else if (
      url.includes('/admin/home/goals') ||
      url.includes('/admin/home/labels') ||
      url.includes('/admin/home/pricing') ||
      url.includes('/admin/home/grades') ||
      url.includes('/admin/home/sizing') ||
      url.includes('/admin/home/week-colors')
    ) {
      this.isMenuItemActive[3] = true;
    } else if (url.includes('/admin/home/analytics/')) {
      this.isMenuItemActive[4] = true;
    } else if (
      url.includes('/admin/home/counting') ||
      url.includes('/admin/home/movement') ||
      url.includes('/admin/home/transfer') ||
      url.includes('/admin/home/onhands') ||
      url.includes('/admin/home/overrides') ||
      url.includes('/admin/home/containers')
    ) {
      this.isMenuItemActive[5] = true;
    } else if (url.includes('/admin/home/barcode')) {
      this.isMenuItemActive[6] = true;
    }
  }

  ngAfterViewInit(): void {
    let topMenu: HTMLElement;
    const toggleSubMenus = (element: HTMLElement) => {
      const subMenus = $(element).closest('li').find('.sub-menu, .sub-menu-wrp');

      if (subMenus.is(':visible')) {
        subMenus.hide();
        this.IsMenuopen = false;
      } else {
        subMenus.show();
        this.IsMenuopen = true;

        $('.menu > ul > li').not($(element).closest('li')).find('.sub-menu, .sub-menu-wrp').hide();

        console.log(subMenus.css('display'));
      }
    };

    $(document).on('click.adminMenu', '.menu > ul > li > .descrWrap > a.first-a', (e: any) => {
      e.stopPropagation();
      topMenu = e.currentTarget;
      toggleSubMenus(e.currentTarget);
    });

    $('.hamburger').on('click.adminMenu', (e: any) => {
      e.stopPropagation();
      toggleSubMenus(topMenu);
    });

    $('.breadcrumbs-section .menu > ul > li').on('click.adminMenu', () => {
      toggleSubMenus(topMenu);
    });

    $(document).on('click.adminMenu', function (e: any) {
      if (!$(e.target).closest('.menu > ul > li').length) {
        $('.menu > ul > li').find('.sub-menu, .sub-menu-wrp').hide();
      }
    });
  }

  ngOnDestroy(): void {
    // Remove the document-level jQuery handlers registered in ngAfterViewInit.
    // Without this, each time the admin shell is re-created (SPA navigation
    // away and back) another set of handlers stacks up on `document`, so the
    // toggle fires N times per click — an even N cancels out and the side
    // menu appears stuck until a full page refresh clears the leaked handlers.
    $(document).off('click.adminMenu');
    $('.hamburger').off('click.adminMenu');
    $('.breadcrumbs-section .menu > ul > li').off('click.adminMenu');
    this.routerSub?.unsubscribe();
  }

  async initializeData() {
    const productionData = await JSON.parse(localStorage.getItem('productionCycle') || '[]');
    if (productionData[0]?.productionColor) {
      this.selectedcolor = productionData[0].productionColor;
    }
  }

  getcompanieslist() {
    // let userdata = this.masterService.getUserDetailsFromStorage();
    // this.masterService
    //   .getcompnaylist(userdata.companyID)
    //   .subscribe((result) => {
    //     this.companieslist = result as Companieslist[];
    //   });
  }

  getBreadcrums() {
    this.adminBreadcrumbs.getbreadcrumbs.subscribe(res => {
      this.breadcrumbs = res as any[];
    });

    const routeURL = this.route.url;
    if (routeURL.includes('admin-home')) {
      this.getDataForMenu(0);
    } else if (
      routeURL.includes('emp-report') ||
      routeURL.includes('production-overview') ||
      routeURL.includes('top-performer')
    ) {
      this.getDataForMenu(1);
    } else if (routeURL.includes('stations')) {
      this.getDataForMenu(2);
    } else if (routeURL.includes('/admin/home/analytics/')) {
      this.getDataForMenu(4);
    } else if (
      routeURL.includes('goals') ||
      routeURL.includes('labels') ||
      routeURL.includes('pricing-config') ||
      routeURL.includes('grades') ||
      routeURL.includes('sizing') ||
      routeURL.includes('week-colors') ||
      routeURL.includes('add-pricing')
    ) {
      this.getDataForMenu(3);
    } else if (routeURL.includes('barcode')) {
      this.getDataForMenu(6);
    } else if (
      routeURL.includes('counting') ||
      routeURL.includes('movement') ||
      routeURL.includes('transfer') ||
      routeURL.includes('onhands') ||
      routeURL.includes('containers')
    ) {
      this.getDataForMenu(5);
    }
  }

  getDataForMenu(indx: number) {
    this.toggleIndex = indx;
    this.isMenuItemActive.forEach((ele, i) => {
      if (indx == i) {
        this.isMenuItemActive[i] = true;
      } else {
        this.isMenuItemActive[i] = false;
      }
    });
  }

  private readonly defaultSubmenuConfig: Record<number, { label: string; getRoute: () => string }> = {
    0: { label: 'Employee Report', getRoute: () => this.empReportRoute },
    1: { label: 'Goals', getRoute: () => '/admin/home/goals' },
    2: { label: 'Item On Hand', getRoute: () => '/admin/home/onhands' }
  };

  onMainMenuClick(indx: number, groupIndex: number) {
    const isAlreadyActive = this.isMenuItemActive[indx];
    this.getDataForMenu(indx);

    if (isAlreadyActive) return;

    const config = this.defaultSubmenuConfig[groupIndex];
    if (!config) return;

    const submenuArray = this.allMenus[groupIndex]?.submenus?.submenuArray ?? [];
    const isDefaultPermitted = submenuArray.some((s: { menu: string }) => s.menu === config.label);

    if (isDefaultPermitted) {
      this.router.navigateByUrl(config.getRoute());
    }
  }

  async loadAnalyticsSubmenus(force = false): Promise<void> {
    if (!this.userInfo?.companyID) {
      return;
    }

    await this.analyticsMenuService.loadMenuItems(this.userInfo.companyID, Apps.TPMPortal, force);
  }

  setUserRoles(): void {
    this.userservice.getUserRolesandPerm().then(res => {
      this.userRoleDetails = this.userservice.userRoles || [];
      this.currentUserRoles = this.userRoleDetails || [];
    });
  }

  getMenulinks(val: string) {
    let newval = val.replace(/\s/g, '');

    this.mainLinks = this.adminBreadcrumbs.allLinks[newval] ?? [];

    if (!this.showWeekColorsMenu && newval === 'CompanyConfig') {
      this.mainLinks = this.mainLinks.filter((item: any) => item.name !== 'Week Colors');
    }
  }

  changeModule() {
    let data = new usersDetails();
    data.userID = this.userInfo.userId;
    data.companyID = this.userInfo.companyID;

    const performNavigation = () => {
      sessionStorage.setItem('isFirstVisit', 'true');
      localStorage.removeItem('stationId');
      localStorage.removeItem('stationName');
      this.router.navigateByUrl('/production/home/departments');
    };

    const isBypassLicense = sessionStorage.getItem('isBypassLicense') === 'true';
    if (isBypassLicense) {
      performNavigation();
    } else {
      this.commonService.unassignStationLicenseAndContinue(performNavigation);
    }
  }

  handleDropdownToggle() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  logout() {
    // Set logout cookie for shared domain
    const domain = environment.domainName;
    const companyweburl = environment.companyWebBaseUrl;
    onUserLogout();

    const performLogout = () => {
      this.onLogout();
      localStorage.clear();
      sessionStorage.clear();
      this.cookie.deleteAll('/', domain);
      document.cookie = `logoutEvent=1; domain=${domain}; path=/; max-age=10`;
      this.userservice.userPermissions = null;
      this.userservice.rolesLoaded = false;
      window.location.href = `${companyweburl}/shared/login`;
    };

    const isBypassLicense = sessionStorage.getItem('isBypassLicense') === 'true';
    if (isBypassLicense) {
      performLogout();
    } else {
      this.commonService.unassignStationLicenseAndContinue(performLogout);
    }
  }

  storeFlag() {
    localStorage.setItem('isFirstPosUser', JSON.stringify('true'));
  }

  getPermissionsByUserId() {
    this.userservice.getUserRolesandPerm().then(res => {
      let permissions = res as UserPermissionsModel[];

      let perm: string[] = [];

      permissions?.forEach(pr => {
        perm.push(pr.name);
      });

      this.allMenus = JSON.parse(JSON.stringify(this.allMenusCopy));

      this.allMenus.forEach((menu: any) => {
        menu.submenus.submenuArray = menu.submenus.submenuArray.filter((submenu: any) =>
          perm.includes(submenu.permission)
        );
      });

      if (!this.showWeekColorsMenu) {
        const companyMenu = this.allMenus.find((menu: any) => menu.menu === 'Company');
        if (companyMenu?.submenus?.submenuArray) {
          companyMenu.submenus.submenuArray = companyMenu.submenus.submenuArray.filter(
            (submenu: any) => submenu.menu !== 'Week Colors'
          );
        }
      }

      this.permissionService.loadPermissions(perm);
      this.loadAnalyticsSubmenus();
    });
  }

  getUserDetails() {
    let userDataFromSession = this.masterService.getUserDetailsFromStorage();
    console.log('User Data from Session:', userDataFromSession);
    if (userDataFromSession != null) {
      this.user = userDataFromSession;
      this.user.isTpmPresent = userDataFromSession.isTpmPresent || false;
      this.user.isPosPresent = userDataFromSession.isPosPresent || false;
      this.user.isDonationPresent = userDataFromSession.isDonationPresent || false;
      this.user.isListerPresent = userDataFromSession.isListerPresent || false;
      this.user.isinventoryPresent = userDataFromSession.isInventoryPresent || false;
    }
    console.log('User Details:', this.user);
    this.setUserRoles();
  }

  redirectToModule(appId: number) {
    switch (appId) {
      case Apps.POS:
        window.location.href = this.posUrl;
        break;
      case Apps.Lister:
        window.location.href = this.listerUrl;
        break;
      case Apps.CompanyPortal:
        window.location.href = this.companyUrl;
        break;
      case Apps.IMS:
        window.location.href = this.inventoryUrl;
        break;
      default:
        console.error('Invalid module name');
        return;
    }
  }

  onRightClick(event: MouseEvent, item: any) {
    event.preventDefault();
    this.selectedApp = item;

    this.contextMenuPosition.x = `${event.clientX}px`;
    this.contextMenuPosition.y = `${event.clientY}px`;
    this.showContextMenu = true;
  }

  openInNewTab() {
    this.showContextMenu = false;
    if (this.selectedApp) {
      const appId = this.selectedApp;
      const url = this.getAppUrl(appId);
      window.open(url, '_blank');
    }
  }

  // Create a method to build the correct URL
  getAppUrl(appId: number): string {
    switch (appId) {
      case Apps.POS:
        return this.posUrl;
      case Apps.CompanyPortal:
        return this.companyUrl;
      case Apps.Lister:
        return this.listerUrl;
      case Apps.IMS:
        return this.inventoryUrl;
      default:
        return '';
    }
  }

  get empReportRoute(): string {
    return getReportRoute('empReport', this.isV3ReportsEnrolled);
  }

  get topPerformerRoute(): string {
    return getReportRoute('topPerformer', this.isV3ReportsEnrolled);
  }

  get sellThroughRoute(): string {
    return getReportRoute('sellThrough', this.isV3ReportsEnrolled);
  }

  get salePerProducerRoute(): string {
    return getReportRoute('salePerProducer', this.isV3ReportsEnrolled);
  }

  get productionOverviewRoute(): string {
    return getReportRoute('productionOverview', this.isV3ReportsEnrolled);
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.showContextMenu = false;
  }

  hideMenu() {
    this.IsMenuopen = false;
    $('.menu > ul > li').find('.sub-menu, .sub-menu-wrp').hide();
  }
  async onLogout(): Promise<void> {
    await this.commonService.logoutCompany(this.userInfo?.userId);
  }
}
